// Freemium usage tracking — synced with admin_settings from Supabase
let _settings = { free_limit: 3, verified_limit: 0, doc_verify_limit: 3, anon_doc_limit: 3, verified_doc_limit: 10, require_email: true };

export async function loadSettings() {
  try {
    const { createClient } = await import('@supabase/supabase-js');
    const sb = createClient('https://mxfjellqpjftpaxyuwve.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im14ZmplbGxxcGpmdHBheHl1d3ZlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY4OTYwNTQsImV4cCI6MjA5MjQ3MjA1NH0.08vKzxr6DFA4f7PLS6goL5duTM58eCSNFhTngfLUIMk');
    const { data } = await sb.from('admin_settings').select('*').single();
    if (data) {
      _settings = { ...data };
      console.log('[Freemium] Settings loaded:', _settings);
    }
  } catch {}
  return _settings;
}

export function getSettings() { return _settings; }

function monthKey(prefix) {
  const d = new Date();
  // Use a stable key that persists across login/logout
  const fp = localStorage.getItem('tf_fp') || 'default';
  return `${prefix}_${fp}_${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

// Analysis count
export function getAnalysisCount() { return parseInt(localStorage.getItem(monthKey('tidjarai_analyses')) || '0'); }
export function incrementAnalysis() { const k = monthKey('tidjarai_analyses'); const c = parseInt(localStorage.getItem(k) || '0') + 1; localStorage.setItem(k, String(c)); return c; }

// Doc verification count
export function getDocVerifyCount() { return parseInt(localStorage.getItem(monthKey('tidjarai_docverify')) || '0'); }
export function incrementDocVerify() { const k = monthKey('tidjarai_docverify'); const c = parseInt(localStorage.getItem(k) || '0') + 1; localStorage.setItem(k, String(c)); return c; }

// Check if analysis is allowed (returns true/false/'needsEmail')
// Check credits from Supabase (cached)
let _userCredits = 0;
export async function loadUserCredits(email) {
  if (!email) return 0;
  try {
    const { createClient } = await import('@supabase/supabase-js');
    const sb = createClient('https://mxfjellqpjftpaxyuwve.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im14ZmplbGxxcGpmdHBheHl1d3ZlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY4OTYwNTQsImV4cCI6MjA5MjQ3MjA1NH0.08vKzxr6DFA4f7PLS6goL5duTM58eCSNFhTngfLUIMk');
    const { data } = await sb.from('leads').select('credits').eq('email', email).single();
    _userCredits = data?.credits || 0;
  } catch {}
  return _userCredits;
}

export function canAnalyze(session) {
  const count = getAnalysisCount();
  if (!session) {
    if (count >= _settings.free_limit) return 'needsEmail';
    return true;
  }
  // Logged in — check credits first
  if (_userCredits > 0) return true; // Has credits, always allow
  if (_settings.verified_limit > 0 && count >= _settings.verified_limit) return 'paywall';
  return true;
}

// Decrement credit after analysis
export async function consumeCredit(email) {
  if (_userCredits <= 0 || !email) return;
  _userCredits--;
  try {
    const { createClient } = await import('@supabase/supabase-js');
    const sb = createClient('https://mxfjellqpjftpaxyuwve.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im14ZmplbGxxcGpmdHBheHl1d3ZlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY4OTYwNTQsImV4cCI6MjA5MjQ3MjA1NH0.08vKzxr6DFA4f7PLS6goL5duTM58eCSNFhTngfLUIMk');
    await sb.from('leads').update({ credits: _userCredits }).eq('email', email);
  } catch {}
}

// Check if doc verification is allowed
export function canVerifyDocs(session) {
  const count = getDocVerifyCount();
  if (!session) {
    if (count >= (_settings.anon_doc_limit || _settings.doc_verify_limit || 3)) return 'needsEmail';
    return true;
  }
  if ((_settings.verified_doc_limit || 0) > 0 && count >= _settings.verified_doc_limit) return 'paywall';
  return true;
}

// Disposable email check
const DISPOSABLE = new Set(['mailinator.com','guerrillamail.com','tempmail.com','yopmail.com','10minutemail.com','throwam.com','trashmail.com','sharklasers.com','fakeinbox.com','mailnesia.com','maildrop.cc','temp-mail.org','mohmal.com']);
export function isDisposableEmail(email) { return DISPOSABLE.has(email.split('@')[1]?.toLowerCase()); }
export function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) && !isDisposableEmail(email); }
export function getFreeLimit() { return _settings.free_limit; }
